/**
 * Shared Routes
 *
 * These routes are accessible to both seekers and providers.
 * Please consider carefully whether you truly need to create a shared route.
 * If you expect a component to have a different UI for seekers and providers,
 * you probably need to create a separate route for each.
 * Otherwise, the logic will get convoluted.
 * If you're afraid about duplicating UI logic, use Storybook.
 */

import { RouteConfig } from 'vue-router';
import adventuresRoutes from './adventuresRoutes';
import doNotSellRoutes from './doNotSellRoutes';
import errorRoutes from './errorRoutes';
import legacyRoutes from './legacyRoutes';
import messagesRoutes from './messagesRoutes';

import deviceSessionsRoutes from './deviceSessionsRoutes';

const sharedRoutes = [
  ...adventuresRoutes,
  ...messagesRoutes,
  ...deviceSessionsRoutes,
  ...doNotSellRoutes,
  ...legacyRoutes,
  ...errorRoutes,
] as RouteConfig[];

export default sharedRoutes;
